import {DataFetcher} from '@aboutyou/data-fetcher';
import {PriceRiseHintResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.types';
import React from 'react';
import {DeleteWithUndoView} from './DeleteWithUndoView';
import {usePriceRiceAlert} from './utils/usePriceRiceAlert';

export interface DeleteWithUndoProps {
  itemKey: string;
  deleteItemWithDelay: VoidFunction;
  deleteItem: VoidFunction;
  onUndoClick: VoidFunction;
  shouldCheckForPriceRise?: boolean;
}

export const DeleteWithUndo: React.FC<DeleteWithUndoProps> = props => {
  return (
    <DataFetcher
      request={usePriceRiceAlert({
        itemKey: props.itemKey,
        disabled: !props.shouldCheckForPriceRise,
      })}
      View={DeleteWithUndoView}
      Error={null}
      viewProps={props}
      computeDefaultState={() =>
        ({
          type: undefined,
        } as PriceRiseHintResponse)
      }
    />
  );
};
